module.exports = __webpack_public_path__ + "img/main-bg1.30d940b2.webp";